import React, { Component } from 'react';
import { Link } from "react-router";
import PropTypes from 'prop-types';
import { database, auth } from '../firebase';
import ms from '../ms';

class Post extends Component {
  constructor(props) {
    super(props);
    this.database = database.ref(`likes`).child(this.props.postId);
    this.state = {
      array: [],
      array2: [],
      userName: '',
      userImage: '',
      likeCount: 0,
      isLiked: false, // added to store the user's like state
    };
  }

  componentWillMount() {
    const userID = auth.currentUser !== null ? auth.currentUser.uid : "x";
    const postID = this.props.postId;
    const likeSayısı = this.state.array;
    const myLike = this.state.array2;

    this.database.on('child_added', snap => {
      if (snap.val().id === userID) myLike.push({ data: snap.val() });
      if (snap.val().liked === true) likeSayısı.push({ data: snap.val() });

      this.setState({
        array: likeSayısı,
        array2: myLike,
        likeCount: likeSayısı.length,
        isLiked: myLike[0] && myLike[0].data.liked, // update the like state
      });

      if (this.state.isLiked) {
        // Set the liked image if the user has liked the post
        document.getElementById(postID + "_img").src = "/liked.png";
      }
    });

    database.ref(`users/${this.props.postAuthor}`).on('value', (snapshot) => {
      if (snapshot.val()) {
        const name = snapshot.val().userName;
        const image = snapshot.val().userImage;
        this.setState({
          userName: name,
          userImage: image,
        });
      }
    });
  }

  handleRemovePost(id) {
    this.props.removePost(id);
  }

  render() {
    return (
      <Link to={`/p/` + this.props.postId}>
        <div className="card">
          <Link to={"/profil/" + this.props.postAuthor}>
            <div className="user-box">
              <img
                src={this.state.userImage || "/default_user.jpg"}
                className="userImage"
                alt="User"
              />
              <div className="userName">{this.state.userName}</div>
            </div>
          </Link>

          <img
            src={this.props.postImage || "/default.jpg"}
            className="banner"
            alt="Yazının Görseli"
          />

          <b className="başlık">{this.props.postTitle}</b>
          <div className="content">{this.props.postContent.replace(/<\/?[^>]+(>|$)/g, "")}</div>

          <div className="likeDiv">
            <div>{this.state.likeCount}</div>
            <img
              src={this.state.isLiked ? "/liked.png" : "/like.png"}
              className="like"
              id={this.props.postId + "_img"}
              alt="Like"
            />
          </div>

          <div className="date">
            {ms(Date.now() - this.props.postDate, { long: true }) + ` önce`}
          </div>

          <style>{`
              .main {
                max-width: 978px;
                width: 100%;
                margin: 0 auto;
                padding: 0;
                text-align: center;
              }
      
              .card {
                border-radius: 20px;
                border-radius: 20px 7px 20px 7px;
                margin: 10px 10px;
                padding: 15px;
                background: #F57029;
                box-shadow: 0px 0px 4px rgba(0,0,0,.0);
                width: 276px;
                max-width: 300px;
                height: 350px;
                text-align: left;
                display: inline-block;
                transition: .2s;
              }

              .card:hover {
                background: #d95e1c;
              }
      
              .card .banner {
                position: relative;
                margin: auto;
                border-radius: 5px;
                width: 100%;
                height: 140px;
                object-fit: cover;
              }

              .user-box {
                display: flex;
                margin-bottom: 10px;
              }

              .userName {
                padding: 8px 0px 0 8px;
                display: block;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }

              .userImage {
                width: 32px;
                height: 32px;
                background: #fff;
                border-radius: 100%;
                object-fit: cover;
              }
      
              h1 {
                margin-top: 100px;
                margin-bottom: 0;
                text-align: center;
              }
      
              h3 {
                margin-bottom: 100px;
                text-align: center;
              }
      
              .başlık {
                display: block;
                font-size: 18px;
                font-weight: 600;
                margin: 8px 0;
                color: #fff;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }

              .content {
                color: #eee;
                display: block;
                font-size: 13px;
                height: 96px;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .likeDiv {
                position: absolute;
                margin-top: 10px;
                font-weight: bold;
              }

              .like {
                position: absolute;
                top: 1px;
                margin-left: 12px;
                width: 20px;
                height: 17px;
              }
      
              .date {
                float: right;
                text-align: right;
                font-weight: bold;
                color: #fff;
                margin: 10px 0 0px 0;
                display: flex;
              }
      
              @media (max-width: 623px) {
                .main {
                  width: 100%;
                  max-width: 100%;
                  padding-top: 50px;
                }
      
                .card {
                  width: 100%;
                  height: auto;
                  max-width: 100%;
                  margin: 0px;
                  padding: 15px 0;
                  border-bottom: 2px solid #2f2d33;
                  border-radius: 0;
                }

                .card:hover {
                  background: #F57029;
                }

                .card .banner {
                  height: auto;
                  max-height: 300px;
                  border-radius: 0;
                }

                .user-box {
                  padding: 0 10px;
                }

                .başlık {
                  padding: 0 10px;
                }

                .content {
                  padding: 0 10px;
                }

                .likeDiv {
                  padding-left: 10px;
                }
      
                .date {
                  margin: 10px 0 0px 0;
                  padding-right: 10px;
                }
              }
            `}</style>

        </div></Link>
    )
  }
}

Post.propTypes = {
  postTitle: PropTypes.string,
  postContent: PropTypes.string,
  postDate: PropTypes.string,
  postImage: PropTypes.string,
  postAuthor: PropTypes.string
}
export default Post;